// src/components/ui/Icons.js
// Iconos SVG 24x24, trazo 1.6, sin relleno, color heredado de currentColor

const base = (props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  ...props,
});

// ============ CATEGORÍAS ============
export const IconRings = (p) => (
  <svg {...base(p)}>
    <circle cx="9" cy="14" r="6" />
    <circle cx="15" cy="14" r="6" />
    <path d="M9 8 L7 5 L11 5 Z" />
    <circle cx="9" cy="4" r="1" />
  </svg>
);

export const IconCake = (p) => (
  <svg {...base(p)}>
    <path d="M4 20h16v-6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v6Z" />
    <path d="M4 16c1.5 0 2-1 3.5-1s2 1 3.5 1 2-1 3.5-1 2 1 3.5 1 1.5-1 3-1" />
    <path d="M12 12V9" />
    <path d="M12 6c0-1 1-1.5 1-2.5" />
    <path d="M8 8v2M16 8v2" />
    <circle cx="12" cy="4" r="0.5" fill="currentColor" />
  </svg>
);

export const IconBaby = (p) => (
  <svg {...base(p)}>
    <circle cx="12" cy="8" r="4" />
    <path d="M9 8.5c0 .5.5 1 1 1M14 8.5c0 .5.5 1 1 1" />
    <path d="M10.5 10.5c.5.5 1.5.5 2 0M12 6.5v.5" />
    <path d="M5 21v-4a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v4" />
  </svg>
);

export const IconCross = (p) => (
  <svg {...base(p)}>
    <path d="M12 3v18M6 9h12M9 13h6" />
  </svg>
);

export const IconGraduationCap = (p) => (
  <svg {...base(p)}>
    <path d="M2 9l10-5 10 5-10 5L2 9Z" />
    <path d="M6 11v5c0 1.5 3 3 6 3s6-1.5 6-3v-5" />
    <path d="M22 9v6" />
  </svg>
);

// ============ ACCIONES ============
export const IconEdit = (p) => (
  <svg {...base(p)}>
    <path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5Z" />
  </svg>
);

export const IconTrash = (p) => (
  <svg {...base(p)}>
    <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
  </svg>
);

export const IconEye = (p) => (
  <svg {...base(p)}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const IconShare = (p) => (
  <svg {...base(p)}>
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    <path d="M16 6l-4-4-4 4M12 2v14" />
  </svg>
);

export const IconCopy = (p) => (
  <svg {...base(p)}>
    <rect x="9" y="9" width="13" height="13" rx="2" />
    <path d="M5 15V5a2 2 0 0 1 2-2h10" />
  </svg>
);

export const IconCheck = (p) => (
  <svg {...base(p)}>
    <path d="M20 6L9 17l-5-5" />
  </svg>
);

export const IconPlus = (p) => (
  <svg {...base(p)}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const IconX = (p) => (
  <svg {...base(p)}>
    <path d="M18 6L6 18M6 6l12 12" />
  </svg>
);

// ============ INFORMACIÓN ============
export const IconCalendar = (p) => (
  <svg {...base(p)}>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M8 3v4M16 3v4M3 10h18" />
  </svg>
);

export const IconClock = (p) => (
  <svg {...base(p)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

export const IconMapPin = (p) => (
  <svg {...base(p)}>
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

export const IconChurch = (p) => (
  <svg {...base(p)}>
    <path d="M12 2v4M10 4h4" />
    <path d="M6 21v-9l6-4 6 4v9" />
    <path d="M6 21h12M9 21v-4a3 3 0 0 1 6 0v4" />
  </svg>
);

export const IconGift = (p) => (
  <svg {...base(p)}>
    <rect x="3" y="8" width="18" height="4" rx="1" />
    <path d="M5 12v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-9M12 8v14" />
    <path d="M12 8a3 3 0 1 0-3-3c0 1.5 1.5 3 3 3ZM12 8a3 3 0 1 1 3-3c0 1.5-1.5 3-3 3Z" />
  </svg>
);

export const IconShirt = (p) => (
  <svg {...base(p)}>
    <path d="M16 3l5 2v4l-2 1v11H5V10L3 9V5l5-2" />
    <path d="M8 3a4 4 0 0 0 8 0" />
  </svg>
);

export const IconCamera = (p) => (
  <svg {...base(p)}>
    <path d="M3 7a2 2 0 0 1 2-2h2l1.5-2h7L17 5h2a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
    <circle cx="12" cy="12.5" r="3.5" />
  </svg>
);

/* export const IconMusic = (p) => (
  <svg {...base(p)}>
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </svg>
); */

export const IconSparkle = (p) => (
  <svg {...base(p)}>
    <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z" />
    <path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15Z" />
  </svg>
);

export const IconHeart = (p) => (
  <svg {...base(p)}>
    <path d="M12 21s-7-4.5-9.5-9A5.5 5.5 0 0 1 12 6.5 5.5 5.5 0 0 1 21.5 12c-2.5 4.5-9.5 9-9.5 9Z" />
  </svg>
);

export const IconStar = (p) => (
  <svg {...base(p)}>
    <path d="M12 2l3 6.5 7 .9-5 4.9 1.2 7L12 18l-6.2 3.3L7 14.3 2 9.4l7-.9L12 2Z" />
  </svg>
);

export const IconBook = (p) => (
  <svg {...base(p)}>
    <path d="M4 4h13a2 2 0 0 1 2 2v14H6a2 2 0 0 1-2-2V4Z" />
    <path d="M4 18a2 2 0 0 1 2-2h13" />
    <path d="M9 7v5M9 7c1 0 1.5.5 1.5 1.5S10 10 9 10" />
  </svg>
);


export const IconDove = (p) => (
  <svg {...base(p)}>
    <path d="M12 6a3 3 0 1 1 6 0c0 2-1.5 3-3 3.5" />
    <path d="M4 12c3-2 6-3 9-3l-2 4c3 0 5 1 7 3-2 3-5 4-9 4-2 0-4-1-5-3-1 0-2-1-2-2s1-2 2-3Z" />
  </svg>
);

export const IconParty = (p) => (
  <svg {...base(p)}>
    <path d="M3 21l6-14 8 8-14 6Z" />
    <path d="M9 7l-1.5-1M14 12l1-1.5M18 3l1 1M22 7l-1 1M14 3v2M19 9h2" />
  </svg>
);

export const IconEnvelope = (p) => (
  <svg {...base(p)}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </svg>
);

export const IconWhatsapp = (p) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);


export const IconFacebook = (p) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M22 12a10 10 0 1 0-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.51 1.5-3.9 3.78-3.9 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.77l-.44 2.89h-2.33v6.99A10 10 0 0 0 22 12Z"/>
  </svg>
);

export const IconTwitter = (p) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231ZM17.083 19.77h1.833L7.084 4.126H5.117Z"/>
  </svg>
);

export const IconTelegram = (p) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

export const IconEmail = (p) => (
  <svg {...base(p)}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </svg>
);

export const IconQr = (p) => (
  <svg {...base(p)}>
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <path d="M14 14h3v3h-3zM20 14v3M14 20h3M20 20h1" />
  </svg>
);

export const IconDownload = (p) => (
  <svg {...base(p)}>
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
  </svg>
);

export const IconLink = (p) => (
  <svg {...base(p)}>
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);


export const IconMusic = (p) => (
  <svg {...base(p)}>
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </svg>
);

export const IconVolume = (p) => (
  <svg {...base(p)}>
    <path d="M11 5L6 9H2v6h4l5 4V5Z" />
    <path d="M15.54 8.46a5 5 0 0 1 0 7.07M19.07 4.93a10 10 0 0 1 0 14.14" />
  </svg>
);

export const IconVolumeOff = (p) => (
  <svg {...base(p)}>
    <path d="M11 5L6 9H2v6h4l5 4V5Z" />
    <path d="M22 9l-6 6M16 9l6 6" />
  </svg>
);

export const IconPause = (p) => (
  <svg {...base(p)}>
    <rect x="6" y="4" width="4" height="16" rx="1" />
    <rect x="14" y="4" width="4" height="16" rx="1" />
  </svg>
);

export const IconPlay = (p) => (
  <svg {...base(p)}>
    <path d="M6 3l14 9-14 9V3Z" />
  </svg>
);

// ============ HELPERS DE CATEGORÍA ============
export const iconForCategory = (category) => {
  const map = {
    Matrimonios: IconRings,
    Cumpleaños: IconCake,
    'Baby Shower': IconBaby,
    Bautizos: IconCross,
    Graduaciones: IconGraduationCap,
  };
  return map[category] || IconSparkle;
};